import Skeleton from "react-loading-skeleton";

const ChatRoomSkeleton = () => {
    return (
        <div className="chat-container" style={{"display":"flex", "flexDirection":"column", "justifyContent": "space-between"}}>
            <div className="listing-link-container" style={{"display":"flex", "flexDirection":"row"}}>
                <div style={{"height":"70px", "width":"70px", "marginRight": "5px", "lineHeight": "0"}}>
                    <Skeleton width="100%" height="100%"/>
                </div>
                    <div style={{"flexGrow":"1"}}>
                        <Skeleton width="50%" height="20%"/>
                        <Skeleton width="10%" height="20%"/>
                        <Skeleton width="20%" height="20%"/>
                    </div>
            </div>
            {/* <div className="chatroom-chat-with">{listing && listing.user.userId === currentUser.uid ? 
                `Selling to ${chatroom.current.from.firstName}`: 
                `Buying from ${chatroom.current.to.firstName}`}</div> */}
            <div className="bottom-aligned">
                <div  className="chat-div" style={{"height":"auto"}}>
                    <Skeleton className="chatmessage sent" width="35%"/>
                    <Skeleton className="chatmessage received" width="55%"/>
                    <Skeleton className="chatmessage sent" width="65%"/>
                    <Skeleton className="chatmessage sent" width="55%"/>
                    <Skeleton className="chatmessage received" width="30%"/>
                    <Skeleton className="chatmessage sent" width="45%"/>
                    <Skeleton className="chatmessage received" width="50%"/>
                    <Skeleton className="chatmessage received" width="40%"/>
                    <Skeleton className="chatmessage sent" width="35%"/>
                    <Skeleton className="chatmessage received" width="55%"/>
                    <Skeleton className="chatmessage sent" width="65%"/>
                    <Skeleton className="chatmessage sent" width="55%"/>
                    <Skeleton className="chatmessage received" width="30%"/>
                    <Skeleton className="chatmessage sent" width="45%"/>
                </div>
                <div>
                    <form id="disabled-form">
                        <input 
                            disabled
                            className="form-control chat-input"
                            value=""
                            type="text"
                        />
                    </form>
                </div>
            </div>
        </div>
    )
}
export default ChatRoomSkeleton
